import {
  CubeTimeDimensionGranularity,
  CubeRequestConfig,
} from '../../../common';
import { SharedOrgMetricsRequestDto } from '../common/shared-org-metrics-request.dto';

export interface WorkingHoursByRangeDistributionRequestDto {
  params: {
    startDate: string;
    endDate: string;
    granularity: CubeTimeDimensionGranularity;
    userIds?: string[];
    //the boundary values will be dictated by the aggregate granularity
    aggregateGranularity: CubeTimeDimensionGranularity;
  } & SharedOrgMetricsRequestDto;
  config: CubeRequestConfig;
}
